<template>
	<page enable-flex>
		<view-list ref="view" work-type="27" :search="{scan: true}">
			<template #filter>
				<m-search>
					<m-search-item label="产品信息">
						<c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
					</m-search-item>
					<m-search-item label="接驳类型">
						<c-radio-group name="handover_type">
							<c-radio value="1">质检接驳</c-radio>
							<c-radio value="2">维修接驳</c-radio>
							<c-radio value="3">销售接驳</c-radio>
						</c-radio-group>
					</m-search-item>
					<m-search-item label="创建时间">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #tag>
						<c-state dict="ACCEPT_REJECT_TYPE" :value="data.handover_type" type="tag"></c-state>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #name>
						{{[data.brand_name, data.model_name, data.memory_name, data.color_name].filter(item => item).join(' ') || '-'}}
					</template>

					<template #state>
						<c-state dict="ACCEPT_REJECT_STATE" :value="data.handover_state_show" type="state"></c-state>
					</template>

					<template #default>
						<c-field label="转交人">{{data.handover_user_name}}</c-field>
						<c-field label="背贴码">{{data.produce_unique_code}}</c-field>
						<c-field label="IMEI">{{data.produce_imei}}</c-field>
						<c-field label="成本价">￥{{data.cost_price}}</c-field>
					</template>

					<template #operate>
						<c-button v-if="data.handover_state == 1 && auth('b_app_examine_accept')" color="main" hollow @click="accpteHandle(data)">接受</c-button>
						<c-button v-if="data.handover_state == 1 && auth('b_app_examine_reject')" color="red" hollow @click="rejectHandle(data)">驳回</c-button>
						<c-button v-if="data.buttons?.cancel_reject?.visible && auth('b_app_examine_cancel_reject')" hollow @click="cancelReject(data)">撤销</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	import handoverReject from '@/mixins/handover_reject'
	export default {
		mixins: [handoverReject],
		data() {
			return {
			}
		},
		
		methods: {
			accpteHandle(data) {
				this.$confirm({
					message: '确认要接受该条记录吗？',
					resolve: () => {
						this.request({
							url: '/handover/accept',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '操作成功'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			rejectHandle(data) {
				this.$confirm({
					message: '确认要驳回该条记录吗？',
					resolve: () => {
						this.request({
							url: '/handover/reject',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '操作成功'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>